import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { getSession } from '../services/storage.service';

@Injectable()
export class LoggedInGuard implements CanActivate {
  constructor(
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkCanActivate();
  }

  private checkCanActivate() {
    const session = getSession();
    if (!session || !session.token) {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/guards/logged-in.guard.ts